import { Link } from 'react-router-dom';
import { Bed, Bath, Maximize, X, Navigation, Eye } from 'lucide-react';
import { formatPrice, formatNumber } from '@/utils/format';
import { StatusBadge } from '@/components/common/StatusBadge';
import { TransactionTypeBadge } from '@/components/common/TransactionTypeBadge';
import { ListingImage } from '@/components/common/ListingImage';

export const MapMiniCard = ({ listing, onClose, onZoomHere }) => {
  if (!listing) return null;

  const streetViewUrl =
    listing.lat != null
      ? `https://www.google.com/maps?layer=c&cbll=${listing.lat},${listing.lng}`
      : null;

  const hasFooter = onZoomHere || streetViewUrl;

  return (
    <div className="absolute bottom-4 left-1/2 z-[500] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 sm:left-4 sm:translate-x-0" data-testid="map-mini-card">
      <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
        <button type="button" onClick={onClose} aria-label="Close" className="absolute right-2 top-2 z-10 grid h-7 w-7 place-items-center rounded-full bg-white/90 text-slate-600 shadow-sm hover:bg-white">
          <X size={15} />
        </button>
        <Link to={`/listing/${listing.id}`} className="flex">
          <ListingImage src={listing.photos?.[0]} alt={listing.address} className="h-28 w-28 shrink-0 object-cover" />
          <div className="min-w-0 p-3">
            <div className="flex flex-wrap items-center gap-1.5">
              <p className="text-lg font-semibold tabular-nums text-slate-900">{formatPrice(listing.price, listing.isRental)}</p>
              <StatusBadge listing={listing} className="text-[10px] px-1.5 py-0" />
              <TransactionTypeBadge isRental={listing.isRental} className="text-[10px] px-1.5 py-0" />
            </div>
            <div className="mt-1 flex items-center gap-3 text-xs text-slate-600">
              <span className="inline-flex items-center gap-1"><Bed size={13} />{listing.beds}</span>
              <span className="inline-flex items-center gap-1"><Bath size={13} />{listing.baths}</span>
              <span className="inline-flex items-center gap-1"><Maximize size={13} />{formatNumber(listing.sqft)}</span>
            </div>
            <p className="mt-1 truncate text-xs text-slate-500">{listing.address}, {listing.city}</p>
            <span className="mt-2 inline-flex text-xs font-medium text-blue-600">View details →</span>
          </div>
        </Link>
        {hasFooter && (
          <div className="flex divide-x divide-slate-100 border-t border-slate-100">
            {onZoomHere && (
              <button
                type="button"
                onClick={() => onZoomHere(listing)}
                className="flex flex-1 items-center justify-center gap-1 py-2 text-xs text-slate-600 hover:bg-slate-50"
              >
                <Navigation size={12} />Zoom Here
              </button>
            )}
            {streetViewUrl && (
              <a
                href={streetViewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-1 items-center justify-center gap-1 py-2 text-xs text-slate-600 hover:bg-slate-50"
                onClick={(e) => e.stopPropagation()}
              >
                <Eye size={12} />Street View
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
